import React from 'react';

const ShippingAddressFormikContext = React.createContext();

export default ShippingAddressFormikContext;
